import classnames from 'classnames';

import { Skeleton } from '@/core/tamagoshi/Skeleton/Skeleton';
import { isB2B } from '@/domains/core/settings/utils';

import styles from './outlineBundleA2C.module.scss';

const OutlineBundleA2CSkel = () => (
  <>
    <div
      data-testid="outline-bundle-a2c-skel"
      className={classnames(styles.priceLabel, styles.priceLabelSkeleton)}
    >
      <Skeleton type="h2" width={85} height={24} />
    </div>

    {isB2B() && (
      <div
        data-testid="outline-bundle-a2c-skel-vat"
        className={classnames(styles.vatLabel, styles.vatLabelSkeleton)}
      >
        <Skeleton type="h3" width={100} height={14} />
      </div>
    )}
  </>
);

OutlineBundleA2CSkel.displayName = 'OutlineBundleA2CSkel';

export default OutlineBundleA2CSkel;
